import styled from 'styled-components';
import TextareaAutosize from 'react-autosize-textarea';
import {transition} from 'helpers/css';

export const Wrapper = styled.div`
  display: grid;
  padding: 16px 16px 16px 49px;
  border-top: 1px solid ${({theme}) => `
    ${theme.variables.borderColor};
  `};
`;

export const Comment = styled.div`
  row-gap: 10px;
  display: grid;
  
  &:not(:last-child) {
    margin: 22px 0;
  }
`;

export const Label = styled.span<{
  type: 'fail' | 'success';
}>`
  column-gap: 12px;
  align-items: center;
  grid-auto-flow: column;
  grid-template-columns: auto 1fr;
  display: inline-grid;
  
  line-height: 20px;
  font-weight: 500;
  font-size: 14px;
  color: ${({type, theme}) => (
    type === 'fail'
  ) ? theme.colors.red : theme.colors.green};
  
  &:before {
    content: "";
    background: ${({type}) => type === 'fail' ? 'url("data:image/svg+xml,%3Csvg width=\'20\' height=\'20\' viewBox=\'0 0 20 20\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z\' fill=\'%23FF647C\'/%3E%3Cpath d=\'M13.1387 6.86097C12.8787 6.60103 12.4572 6.60103 12.1972 6.86097L10.0045 9.05365L7.81182 6.86097C7.55055 6.60863 7.13524 6.61224 6.8784 6.86908C6.62155 7.12593 6.61795 7.54123 6.87029 7.8025L9.06297 9.99518L6.87029 12.1879C6.69719 12.355 6.62777 12.6026 6.68871 12.8354C6.74965 13.0682 6.93146 13.25 7.16426 13.311C7.39707 13.3719 7.64464 13.3025 7.81182 13.1294L10.0045 10.9367L12.1972 13.1294C12.4584 13.3817 12.8737 13.3781 13.1306 13.1213C13.3874 12.8644 13.391 12.4491 13.1387 12.1879L10.946 9.99518L13.1387 7.8025C13.3986 7.54248 13.3986 7.12099 13.1387 6.86097Z\' fill=\'white\'/%3E%3C/svg%3E%0A");' : 'url("data:image/svg+xml,%3Csvg width=\'20\' height=\'20\' viewBox=\'0 0 20 20\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z\' fill=\'%2300C48C\'/%3E%3Cpath d=\'M12.9111 7.71536C13.1983 7.42821 13.6638 7.42821 13.951 7.71536C14.2381 8.00251 14.2381 8.46808 13.951 8.75523L9.53921 13.167C9.25206 13.4541 8.7865 13.4541 8.49935 13.167L6.04837 10.716C5.76122 10.4289 5.76122 9.9633 6.04837 9.67615C6.33552 9.389 6.80108 9.389 7.08823 9.67615L9.01928 11.6072L12.9111 7.71536Z\' fill=\'white\'/%3E%3C/svg%3E%0A")'};
    border-radius: 50%;
    height: 20px;
    width: 20px;
  }
`;

export const Value = styled(TextareaAutosize)`
  ${transition()};
  resize: none;
  margin-left: 32px;
  padding: 0;
  
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  
  &:focus::placeholder {
    opacity: 0;
  }
`;
